const defaultHolidaysForm = {
    id: null,
    commercial: null,
    begin: null,
    end: null,
    type: null,
    is_accepted: false,
    file: null,
}

export default defaultHolidaysForm;